import React, { useState, useEffect, useContext } from "react";
import { useFormikContext } from "formik";
import CsplTextBoxField from "../../CsplControls/CsplTextBox/CsplTextBoxField";
import CsplAchField from "../../CsplControls/CsplAch/CsplAchField";
import CsplDateField from "../../CsplControls/CsplDate/CsplDateField";
import CsplRadioButtonField from "../../CsplControls/CsplRadioButton/CsplRadioButtonField";
import GaurdianNominee from "./GaurdianNominee";
import { NomineesEnum } from "../../../Enumeration/NomineesEnum";
import { OptionsEnum } from "../../../Enumeration/OptionsEnum";
import KycApplicationContext from "../../../Context/KYCApplicationContext/KYCApplicationContext";
import UseFormikHelper from "../../../Utils/UseFormikHelper";
import styles from "./NominationDetail.module.css";
import { useTranslation } from "react-i18next";
import { TagEnum } from "../../../Enumeration/TagEnum";
import { TagValueEnum } from "../../../Enumeration/TagValueEnum";
import TagValueResource from "../../Resources/CommonResources/TagValueResource";
import CountryResource from "../../Resources/CommonResources/CountryResource";
import {
  VIEW_MODE,
  defaultMobileCountryCode,
} from "../../../Utils/GlobalValues";

//NomineeDetail Component
export default function NomineeDetail() {
  const { t } = useTranslation("common");
  const [countryId, setCountryId] = useState();
  const [disable, setDisable] = useState(true);
  const [relationshipId, setRelationshipId] = useState(null);
  const applicationContext = useContext(KycApplicationContext);
  let mode = applicationContext.mode;
  const { values, setFieldValue } = useFormikContext();
  const { clearFieldValue } = UseFormikHelper();
  const [getTagValue] = TagValueResource();
  const { getCountryByMobileCountryCode } = CountryResource();
  //Set enable/disable the control
  // disable if it is in view mode
  let isDisabled = applicationContext.disableForm;

  //show Guardian details if user is minor
  const radioValueList = [OptionsEnum.Yes, OptionsEnum.No];

  //residential status list
  const residentialStatusList = [
    OptionsEnum.Resident,
    OptionsEnum.Non_Resident_Indian,
    OptionsEnum.OCI_Card_Holder,
    OptionsEnum.Non_Resident_Others,
  ];

  useEffect(() => {
    const currentStatus = values?.nomineeWidgetDTO?.nominee1?.residentialStatus;

    if (currentStatus === OptionsEnum.Non_Resident) {
      values.nomineeWidgetDTO.nominee1.residentialStatus =
        OptionsEnum.Non_Resident_Indian;
    }
  }, [values, setFieldValue]);

  const handleRelationship = (newValue) => {
    if (newValue && newValue.name === NomineesEnum.relationship_others) {
      setDisable(false);
      values.nomineeWidgetDTO.nominee1.otherRelationshipRequired = true;
    } else if (newValue && newValue.name !== NomineesEnum.relationship_others) {
      setDisable(true);
      values.nomineeWidgetDTO.nominee1.otherRelationship = "";
      values.nomineeWidgetDTO.nominee1.otherRelationshipRequired = false;
    }
  };

  //If User Select relationship as 'Others', enable the textbox
  useEffect(() => {
    if (
      values.nomineeWidgetDTO.nominee1 !== null &&
      values.nomineeWidgetDTO.nominee1.relationship !== null
    ) {
      handleRelationship(values.nomineeWidgetDTO.nominee1.relationship);
    } else if (
      values.nomineeWidgetDTO.nominee1 !== null &&
      values.nomineeWidgetDTO.nominee1.relationship === null
    ) {
      handleRelationship({ name: NomineesEnum.relationship_nan });
    }
  }, [relationshipId, handleRelationship]);

  //handling country change
  const handleCountryChange = (value) => {
    setFieldValue("nomineeWidgetDTO.nominee1.state", null);
    if (value && value.mobileCountryCode && value.mobileCountryCode != "") {
      setFieldValue("nomineeWidgetDTO.nominee1.mobileCountry", value);
    } else {
      setFieldValue("nomineeWidgetDTO.nominee1.mobileCountry", null);
    }
  };

  //Handle Gaurdian Based on Minor
  const handleGaurdianBasedOnMinor = (e) => {
    setFieldValue(e.target.name, e.target.value);
    if (e.target.value === OptionsEnum.Yes) {
      values.nomineeWidgetDTO.nominee1.guardianDTO.isMinor = OptionsEnum.Yes;
    } else {
      clearFieldValue(
        "nomineeWidgetDTO.nominee1.guardianDTO.relationship",
        null,
      );
      clearFieldValue("nomineeWidgetDTO.nominee1.guardianDTO", {});
      setFieldValue(
        "nomineeWidgetDTO.nominee1.guardianDTO.isMinor",
        OptionsEnum.No,
      );
    }
    clearFieldValue("nomineeWidgetDTO.nominee1.relationship", null);
  };

  //Handle bank account type based on residential status
  const handleBankAccountTypeOnChange = (e) => {
    setFieldValue(e.target.name, e.target.value);

    clearFieldValue("nomineeWidgetDTO.nominee1.country", null);

    clearFieldValue("nomineeWidgetDTO.nominee1.mobileCountry", null);

    clearFieldValue("nomineeWidgetDTO.nominee1.state", null);

    setAccountType(e.target.value);
  };

  function setAccountType(residentialStatus) {
    if (OptionsEnum.Resident === residentialStatus) {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee1.bankAccountType", res);
        },
        (error) => {},
      );
    } else {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.NROSAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee1.bankAccountType", res);
        },
        (error) => {},
      );
    }
  }

  //set default values
  useEffect(() => {
    if (values && values.nomineeWidgetDTO && values.nomineeWidgetDTO.nominee1) {
      //set default account type
      setdefaultAccountType();

      // set default mobile country
      setdefaultMobileCountry();
    }
  }, []);

  /* set default account type */
  function setdefaultAccountType() {
    if (
      values.nomineeWidgetDTO.nominee1.bankAccountType == null &&
      (OptionsEnum.Resident ===
        values.nomineeWidgetDTO.nominee1.residentialStatus ||
        values.nomineeWidgetDTO.nominee1.residentialStatus == undefined)
    ) {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.SAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee1.bankAccountType", res);
        },
        (error) => {},
      );
    } else if (
      values.nomineeWidgetDTO.nominee1.bankAccountType == null &&
      OptionsEnum.Non_Resident ===
        values.nomineeWidgetDTO.nominee1.residentialStatus
    ) {
      getTagValue(TagEnum.ACCOUNTTYPE, TagValueEnum.NROSAVINGS).then(
        (res) => {
          setFieldValue("nomineeWidgetDTO.nominee1.bankAccountType", res);
        },
        (error) => {},
      );
    } else {
      //do nothing
    }
  }

  //set default mobile country
  function setdefaultMobileCountry() {
    if (
      values.nomineeWidgetDTO.nominee1.mobileCountry == null ||
      values.nomineeWidgetDTO.nominee1.mobileCountry == undefined
    ) {
      getCountryByMobileCountryCode(defaultMobileCountryCode).then(
        (res) => {
          console.log(res);
          setFieldValue("nomineeWidgetDTO.nominee1.mobileCountry", res);
        },
        (error) => {},
      );
    }
  }

  return (
    <>
      {/* get the Nominee Details*/}
      <div className="content_body">
        <div className="row ">
          {/* Overall width control */}
          <div className="col-lg-8 col-sm-11 col-12 mx-auto ">
            <p>
              <span className={styles.file_instruction}>
                {t("nominee.nomineeHelpText")}
              </span>
            </p>
            {/*Is the Nominee Minor*/} {/*Is Yes ,DoB*/}
            <div className="col-sm-11 col-12 me-auto mb-4">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplRadioButtonField
                    valuelist={radioValueList}
                    disabled={isDisabled}
                    rowdisplay={true}
                    label={"nominee.nomineeMinor"}
                    name="nomineeWidgetDTO.nominee1.isMinor"
                    defaultValue={OptionsEnum.No}
                    onChange={handleGaurdianBasedOnMinor}
                  ></CsplRadioButtonField>
                </div>

                <div className="w-100 mt-md-2">
                  <div className="w-100 mt-md-1">
                    <CsplDateField
                      name="nomineeWidgetDTO.nominee1.minorDOB"
                      required={true}
                      label={"nominee.dob"}
                      disabled={isDisabled}
                      id="startDate"
                    ></CsplDateField>
                  </div>
                </div>
              </div>
            </div>
            {/* Prefix & Name */}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <div className="d-flex justify-content-between">
                <div className="w-50 me-3 ">
                  <CsplAchField
                    lookupName={"salutations"}
                    displayColumn="shortName"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee1.salutation"
                    required={true}
                    label={"nominee.prefix"}
                    disabled={isDisabled}
                    id="salutation"
                  ></CsplAchField>
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee1.name"
                    required={true}
                    label={"nominee.name"}
                    disabled={isDisabled}
                    id="name"
                    defaultValue={null}
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>
            {/*Relationship & otherRelationship*/}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    lookupName={"nomineeRelationship"}
                    displayColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee1.relationship"
                    required={true}
                    label={"nominee.relationshipWithAccountHolder"}
                    disabled={isDisabled}
                    id="relationship"
                    getIdValue={setRelationshipId}
                    filterValue={values.nomineeWidgetDTO.nominee1.isMinor}
                  ></CsplAchField>
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee1.otherRelationship"
                    required={
                      values.nomineeWidgetDTO.nominee1.otherRelationshipRequired
                    }
                    disabled={isDisabled || disable}
                    label={"nominee.otherRelationship"}
                    id="otherRelationship"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>
            {/*Residential Status*/}
            <div className="col-sm-11 col-12 mb-0 me-auto">
              <CsplRadioButtonField
                valuelist={residentialStatusList}
                disabled={isDisabled}
                rowdisplay={true}
                label={"nominee.residentialStatus"}
                name="nomineeWidgetDTO.nominee1.residentialStatus"
                defaultValue={OptionsEnum.Resident}
                onChange={handleBankAccountTypeOnChange}
              ></CsplRadioButtonField>
            </div>
            <div className="col-sm-11 col-12 mt-0 mb-4 me-auto">
              {t("nominee.nominee_nro_text")}
            </div>
            {/*AddressLine1*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.addressLine1"
                required={false}
                label={"nominee.addressLine1"}
                disabled={isDisabled}
                id="addressLine1"
              ></CsplTextBoxField>
            </div>
            {/*AddressLine2*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.addressLine2"
                required={false}
                label={"nominee.addressLine2"}
                disabled={isDisabled}
                id="addressLine2"
              ></CsplTextBoxField>
            </div>
            {/*AddressLine3*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.addressLine3"
                required={false}
                label={"nominee.addressLine3"}
                disabled={isDisabled}
                id="addressLine3"
              ></CsplTextBoxField>
            </div>
            {/* City & Country */}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee1.city"
                    required={true}
                    label={"nominee.city"}
                    disabled={isDisabled}
                    id="city"
                  ></CsplTextBoxField>
                </div>
                <div className="w-100">
                  <CsplAchField
                    lookupName={"countryForNominee"}
                    displayColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee1.country"
                    required={true}
                    label={"nominee.country"}
                    disabled={isDisabled}
                    id="country"
                    getIdValue={setCountryId}
                    onValueChange={handleCountryChange}
                    filterValue={
                      values.nomineeWidgetDTO.nominee1.residentialStatus
                    }
                  ></CsplAchField>
                </div>
              </div>
            </div>
            {/* State & Pincode */}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    lookupName="state"
                    displayColumn="name"
                    idColumn="id"
                    id="state"
                    label="nominee.state"
                    name="nomineeWidgetDTO.nominee1.state"
                    required={true}
                    filterValue={countryId}
                    disabled={isDisabled}
                  />
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee1.pincode"
                    required={true}
                    label={"nominee.pincode"}
                    disabled={isDisabled}
                    id="pincode"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>
            {/* Mobile country code & Mobile no */}
            <div className="col-sm-11 col-sm-11 col-12 mb-4 me-auto">
              <div className="d-md-flex justify-content-between">
                <div className="w-100 me-3 mb-md-0 mb-sm-4 mb-4">
                  <CsplAchField
                    lookupName={"countryCodeForNominee"}
                    displayColumn="mobileCountryCode"
                    secondaryColumn="name"
                    idColumn="id"
                    name="nomineeWidgetDTO.nominee1.mobileCountry"
                    required={
                      values.nomineeWidgetDTO.nominee1.isMinor ===
                      OptionsEnum.No
                    }
                    label={"nominee.mobileCountryCode"}
                    disabled={isDisabled}
                    id="nominee1Mobilecountry"
                    filterValue={
                      values.nomineeWidgetDTO.nominee1.residentialStatus
                    }
                  />
                </div>
                <div className="w-100">
                  <CsplTextBoxField
                    name="nomineeWidgetDTO.nominee1.mobileNo"
                    required={
                      values.nomineeWidgetDTO.nominee1.isMinor ===
                      OptionsEnum.No
                    }
                    label={"nominee.mobileno"}
                    disabled={isDisabled}
                    id="mobileno"
                  ></CsplTextBoxField>
                </div>
              </div>
            </div>
            {/*Email*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.emailId"
                required={true}
                label={"nominee.email"}
                disabled={isDisabled}
                id="email"
              ></CsplTextBoxField>
            </div>
            {/*Bank Name*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.bankName"
                required={false}
                label={"nominee.bankName"}
                disabled={isDisabled}
                id="nominee1BankName"
              ></CsplTextBoxField>
            </div>
            {/*IFSC code*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.ifscCode"
                required={false}
                label={"nominee.ifscCode"}
                disabled={isDisabled}
                id="nominee1IfscCode"
              ></CsplTextBoxField>
            </div>
            {/*Branch Name*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.branchName"
                required={false}
                label={"nominee.branchName"}
                disabled={isDisabled}
                id="nominee1BranchName"
              ></CsplTextBoxField>
            </div>
            {/*Bank Account Number*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplTextBoxField
                name="nomineeWidgetDTO.nominee1.bankAccountNumber"
                required={false}
                label={"nominee.bankAccNo"}
                disabled={isDisabled}
                id="nominee1BankAccNo"
              ></CsplTextBoxField>
            </div>
            {/*Bank Account Type accountType*/}
            <div className="col-sm-11 col-12 mb-4 me-auto">
              <CsplAchField
                lookupName={"accountTypeForResidentialStatus"}
                displayColumn="name"
                idColumn="id"
                name="nomineeWidgetDTO.nominee1.bankAccountType"
                required={false}
                label={"nominee.bankAccType"}
                disabled={isDisabled}
                id="nominee1BankAccType"
                filterValue={values.nomineeWidgetDTO.nominee1.residentialStatus}
              ></CsplAchField>
            </div>
          </div>

          <div className="col-lg-8 col-sm-11 col-12 mx-auto ">
            {values !== undefined &&
              values.nomineeWidgetDTO.nominee1 !== undefined &&
              values.nomineeWidgetDTO.nominee1.isMinor !== OptionsEnum.No && (
                <div className="">
                  <GaurdianNominee />
                </div>
              )}
          </div>
          {mode && mode !== VIEW_MODE && (
            <>
              {" "}
              <br /> <br /> <br />{" "}
            </>
          )}
        </div>
      </div>
    </>
  );
}
